module.exports = __webpack_public_path__ + "static/media/word.8e788ef7.svg";